import React, { useContext, useEffect } from "react";
import { BCBSIL, BCBSTX, BCBSNM, BCBSOK, BCBSMT } from "../assets/icons";
import { StateContext } from "../context/stateContext";
import Footer from "./footer/Footer";
import Header from "./Header/Header";
import Main from "./main1";

interface ILayout {
  desktopLeftMain?: string | React.ReactNode;
  desktopRightMain?: string | React.ReactNode;
  fullWidthFooter?: string | React.ReactNode;
  footer?: string | React.ReactNode;
  desktopLeftFooter?: string | React.ReactNode;
  desktopRightFooter?: string | React.ReactNode;
  main?: boolean;
  backButton: boolean;
  onBackBtnClick: () => void;
}

const Layout: React.FC<ILayout> = ({
  desktopLeftMain,
  desktopRightMain,
  main,
  fullWidthFooter,
  footer,
  desktopLeftFooter,
}) => {
  const { stateUSACode } = useContext(StateContext);
  useEffect(() => {
    let href;
    switch (stateUSACode) {
      case "tx":
        href = BCBSTX;
        break;
      case "mt":
        href = BCBSMT;
        break;
      case "nm":
        href = BCBSNM;
        break;
      case "ok":
        href = BCBSOK;
        break;
      default:
        href = BCBSIL;
    }
    const icon = document.createElement("link");
    icon.rel = "icon";
    icon.href = href;
    document.getElementsByTagName("head")[0].appendChild(icon);
  }, [stateUSACode]);
  return (
    <div>
      <Header />
      <Main desktopLeftMain={desktopLeftMain} desktopRightMain={desktopRightMain} main={main} />
      <Footer footer={footer} fullWidthFooter={fullWidthFooter} desktopLeftFooter={desktopLeftFooter} />
    </div>
  );
};
export default Layout;
